import React, { useState, useEffect } from 'react';
import Highcharts from 'highcharts';
import { HighchartsChart, Chart, XAxis, withHighcharts, YAxis, PlotLine, ColumnSeries, } from 'react-jsx-highcharts';
const FullNoiseGraphEL = ({ data, count, startTime, endTime }) => {
    const [columnData, setcolumnData] = useState([]);
    const plotOptions = {
        column: { grouping: false },
        series: {
            animation: false,
            pointPadding: 0,
            groupPadding: 0,
            borderWidth: 0,
            opacity: 1,
            pointStart: 0,
            states: {
                hover: { enabled: false },
            },
        },
    };
    // We have to have our x values multiplied by 1000 to treat them as milliseconds
    useEffect(() => {
        const newData = data.map((item, index) => {
            const dataObj = { x: index, y: item, color: '#82a6ad' };
            if (item > 80) {
                dataObj.color = '#430a4a';
            }
            else if (item > 75) {
                dataObj.color = '#75085c';
            }
            else if (item > 70) {
                dataObj.color = '#a11a4d';
            }
            else if (item > 65) {
                dataObj.color = '#cd463e';
            }
            else if (item > 60) {
                dataObj.color = '#e87e4d';
            }
            else if (item > 55) {
                dataObj.color = '#f3c683';
            }
            else if (item > 50) {
                dataObj.color = '#e2f2bf';
            }
            else if (item > 45) {
                dataObj.color = '#cee4cc';
            }
            else if (item > 40) {
                dataObj.color = '#b8d6d1';
            }
            else if (item > 35) {
                dataObj.color = '#a0babf';
            }
            return dataObj;
        });
        setcolumnData(newData);
    }, [data]);
    // Since Highcharts deals in milliseconds, our max XAxis value is multiplied by 1000.
    return (React.createElement("div", null,
        React.createElement(HighchartsChart, { plotOptions: plotOptions },
            React.createElement(Chart, { type: 'column', height: 300, spacingTop: 15, scrollablePlotArea: { scrollPositionX: 0 } }),
            React.createElement(XAxis, { min: 0, max: endTime - startTime, labels: {
                    enabled: true,
                    style: { color: '#2e384d' },
                    format: '{value}',
                }, minorTickWidth: 1, minorTickLength: 5, minorTickInterval: 1, tickInterval: 5, minorGridLineWidth: 0, minorTickColor: '#ccd6eb' },
                React.createElement(PlotLine, { color: '#0856ca', value: count - startTime, width: 1, zIndex: 5 }),
                React.createElement(PlotLine, { color: '#ccd6eb', value: 0, width: 1, zIndex: 5, dashStyle: "dash" })),
            React.createElement(YAxis, { min: 40, softMax: 80, minorTickWidth: 1, minorTickLength: 20, minorTickInterval: 20, minorGridLineWidth: 0, minorTickColor: '#ccd6eb', tickColor: '#ccd6eb', tickInterval: 20, startOnTick: false, labels: {
                    enabled: true,
                    style: { color: '#2e384d' },
                    format: '{value}dB',
                    x: -5,
                    y: -2,
                } },
                React.createElement(ColumnSeries, { name: "Noise", data: columnData })))));
};
export const FullNoiseGraph = withHighcharts(FullNoiseGraphEL, Highcharts);
//# sourceMappingURL=FullNoiseGraph.js.map